<template>
  <div
    class="events box h-100"
    @scroll="onScroll"
    :class="{
      'd-flex align-items-center text-center': !selectedDatesEvents.length,
    }"
  >
    <table class="w-100">
      <tbody>
        <tr v-for="(event, index) in selectedDatesEvents" :key="index">
          <div
            class="event"
            :class="{
              'is-current':
                event.startDate < currentDate && event.endDate > currentDate,
            }"
            :style="{
              color: event.color,
              backgroundColor: event.color + '26',
              borderColor: event.color,
            }"
          >
            <p class="font-weight-bold">{{ event.title }}</p>
            <p class="mt-0 small">{{ event.customer }}</p>
            <p class="mt-0 small">{{ event.comments }}</p>
            <hr style="margin: 5px 0px 5px 0px" />
            <p class="mt-0 small font-weight-bold">{{ event.resource }}</p>
            <p class="mt-0 font-weight-bold">
              {{
                String(event.startDate.getHours()).padStart(2, "0") +
                ":" +
                String(event.startDate.getMinutes()).padStart(2, "0") +
                " – " +
                String(event.endDate.getHours()).padStart(2, "0") +
                ":" +
                String(event.endDate.getMinutes()).padStart(2, "0")
              }}
            </p>
          </div>
        </tr>
        <tr v-if="!selectedDatesEvents.length">
          <p>Es existieren keine Buchungen</p>
        </tr>
        <tr v-if="hasError" class="alert alert-danger mt-3">
          Es besteht ein Fehler mit der Verbindung zum Server.
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { bookingCache } from "../store/bookingCache";

export default {
  props: {
    date: Date,
    resource: String,
  },
  data() {
    return {
      currentDate: new Date(),
      lastDate: null,
      events: [],
      hasError: false,
      cacheUnsubscribe: null,
    };
  },
  computed: {
    selectedDate() {
      return this.date;
    },
    selectedDatesEvents() {
      if (Array.isArray(this.events)) {
        return this.events.filter((event) => {
          return this.eventIsOnSelectedDate(event.startDate, event.endDate);
        });
      } else return true;
    },
  },
  watch: {
    // Fetch events for new date if it changes
    date() {
      // Only fetch if date actually changed
      if (!this.lastDate || !this.isSameDay(this.lastDate, this.date)) {
        this.getEventsForDate(this.date);
      }

      this.lastDate = this.date;
    },
  },
  created() {
    // Subscribe to booking cache updates
    this.cacheUnsubscribe = bookingCache.subscribe((date, events) => {
      this.events = bookingCache.getAll();
    });
  },
  mounted() {
    // Load events from cache (Calendar component handles fetching)
    this.events = bookingCache.getAll();

    setInterval(() => {
      this.updateTime();
    }, 1000);
  },
  beforeDestroy() {
    // Unsubscribe from cache updates
    if (this.cacheUnsubscribe) {
      this.cacheUnsubscribe();
    }
  },
  methods: {
    updateTime() {
      this.currentDate = new Date();
    },
    eventIsOnSelectedDate(startDate, endDate) {
      // Reset time to search full-day
      this.selectedDate.setHours(0, 0, 0, 0);

      let nextDate = new Date(
        this.selectedDate.getFullYear(),
        this.selectedDate.getMonth(),
        this.selectedDate.getDate() + 1,
        0,
        0
      );

      if (endDate > this.selectedDate && startDate < nextDate) {
        return true;
      } else {
        return false;
      }
    },
    onScroll() {
      this.$emit("scroll");
    },

    // Helper to check if two dates are the same day
    isSameDay(date1, date2) {
      return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
      );
    },

    // Fetch events for a specific date
    async getEventsForDate(date) {
      try {
        await bookingCache.fetchDate(this.resource, date);
        this.events = bookingCache.getAll();

        if (this.hasError) {
          this.hasError = false;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error loading events:", error);
        this.hasError = true;
      }
    },
    // Reload events (called by App.vue polling interval)
    reloadEvents() {
      if (this.selectedDate) {
        // Clear cache to force fresh fetch
        bookingCache.clear();
        this.getEventsForDate(this.selectedDate);
      }
    },
  },
};
</script>
